import React from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { LogOut, ShieldCheck, Brain, BarChart3 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Layout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const navItems = [
    { to: "/", label: "Dashboard", icon: BarChart3 },
    { to: "/ai-board", label: "AI Board", icon: Brain },
  ];

  return (
    <div data-testid="layout-root" className="min-h-screen flex flex-col">
      <header className="border-b border-white/10 bg-ink-900">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-4">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-3">
              <div className="h-8 w-8 rounded bg-accent-500 text-ink-950 grid place-items-center font-bold">A</div>
              <div>
                <div className="text-sm tracking-wide text-white/60">AmeMan</div>
                <h1 data-testid="layout-title" className="text-lg font-semibold">{title || "Dashboard"}</h1>
              </div>
            </div>
            <nav className="flex items-center gap-1">
              {navItems.map(({ to, label, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={to === "/"}
                  data-testid={`nav-${to.replace("/", "") || "home"}`}
                  className={({ isActive }) =>
                    `inline-flex items-center gap-1.5 rounded px-3 py-1.5 text-sm transition ${
                      isActive ? "bg-accent-500 text-ink-950" : "text-white/70 hover:bg-white/5"
                    }`
                  }
                >
                  <Icon size={14} /> {label}
                </NavLink>
              ))}
            </nav>
          </div>
          {user ? (
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 text-sm text-white/70">
                <ShieldCheck size={16} className="text-accent-500" />
                <span data-testid="layout-user-info">{user.name} ({user.role})</span>
              </div>
              <button
                data-testid="layout-logout-btn"
                type="button"
                onClick={handleLogout}
                className="inline-flex items-center gap-2 rounded border border-white/15 px-3 py-1.5 text-sm hover:bg-white/5"
              >
                <LogOut size={14} /> Iesire
              </button>
            </div>
          ) : null}
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl flex-1 px-6 py-8">{children}</main>
      <footer className="border-t border-white/5 px-6 py-3 text-center text-xs text-white/40">
        AmeMan {new Date().getFullYear()} - Amel International Group
      </footer>
    </div>
  );
}
